// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Additional Utility Classes and Component Styles */

/* ==========================================================================
   Layout Utilities
   ========================================================================== */

/* Container Variations */
.container-fluid {
  width: 100%;
  padding: 0 var(--spacing-4);
}

.container-narrow {
  max-width: 600px;
  margin: 0 auto;
  padding: 0 var(--spacing-4);
}

.container-wide {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 var(--spacing-4);
}

/* Section Spacing */
.section {
  padding: var(--spacing-20) 0;
}

.section-sm {
  padding: var(--spacing-12) 0;
}

.section-lg {
  padding: var(--spacing-32) 0;
}

.section-xl {
  padding: var(--spacing-40) 0;
}

/* ==========================================================================
   Typography Utilities
   ========================================================================== */

/* Text Sizes (Extended) */
.text-4xl { font-size: var(--font-size-4xl); }
.text-5xl { font-size: var(--font-size-5xl); }
.text-6xl { font-size: var(--font-size-6xl); }
.text-7xl { font-size: var(--font-size-7xl); }
.text-8xl { font-size: var(--font-size-8xl); }
.text-9xl { font-size: var(--font-size-9xl); }

/* Font Weights (Extended) */
.font-thin { font-weight: var(--font-weight-thin); }
.font-extralight { font-weight: var(--font-weight-extralight); }
.font-extrabold { font-weight: var(--font-weight-extrabold); }
.font-black { font-weight: var(--font-weight-black); }

/* Line Heights */
.leading-none { line-height: var(--line-height-none); }
.leading-tight { line-height: var(--line-height-tight); }
.leading-snug { line-height: var(--line-height-snug); }
.leading-normal { line-height: var(--line-height-normal); }
.leading-relaxed { line-height: var(--line-height-relaxed); }
.leading-loose { line-height: var(--line-height-loose); }

/* Letter Spacing */
.tracking-tighter { letter-spacing: var(--letter-spacing-tighter); }
.tracking-tight { letter-spacing: var(--letter-spacing-tight); }
.tracking-normal { letter-spacing: var(--letter-spacing-normal); }
.tracking-wide { letter-spacing: var(--letter-spacing-wide); }
.tracking-wider { letter-spacing: var(--letter-spacing-wider); }
.tracking-widest { letter-spacing: var(--letter-spacing-widest); }

/* Text Colors (Extended) */
.text-success { color: var(--color-success); }
.text-warning { color: var(--color-warning); }
.text-error { color: var(--color-error); }
.text-info { color: var(--color-info); }
.text-white { color: white; }
.text-black { color: black; }

/* Text Utilities */
.text-uppercase { text-transform: uppercase; }
.text-lowercase { text-transform: lowercase; }
.text-capitalize { text-transform: capitalize; }
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-clip {
  text-overflow: clip;
}

/* ==========================================================================
   Spacing Utilities (Extended)
   ========================================================================== */

/* Margin Utilities */
.m-1 { margin: var(--spacing-1); }
.m-2 { margin: var(--spacing-2); }
.m-3 { margin: var(--spacing-3); }
.m-4 { margin: var(--spacing-4); }
.m-5 { margin: var(--spacing-5); }
.m-6 { margin: var(--spacing-6); }
.m-8 { margin: var(--spacing-8); }
.m-10 { margin: var(--spacing-10); }
.m-12 { margin: var(--spacing-12); }
.m-16 { margin: var(--spacing-16); }
.m-20 { margin: var(--spacing-20); }
.m-24 { margin: var(--spacing-24); }
.m-32 { margin: var(--spacing-32); }

/* Margin X-axis */
.mx-1 { margin-left: var(--spacing-1); margin-right: var(--spacing-1); }
.mx-2 { margin-left: var(--spacing-2); margin-right: var(--spacing-2); }
.mx-3 { margin-left: var(--spacing-3); margin-right: var(--spacing-3); }
.mx-4 { margin-left: var(--spacing-4); margin-right: var(--spacing-4); }
.mx-6 { margin-left: var(--spacing-6); margin-right: var(--spacing-6); }
.mx-8 { margin-left: var(--spacing-8); margin-right: var(--spacing-8); }

/* Margin Y-axis */
.my-1 { margin-top: var(--spacing-1); margin-bottom: var(--spacing-1); }
.my-2 { margin-top: var(--spacing-2); margin-bottom: var(--spacing-2); }
.my-3 { margin-top: var(--spacing-3); margin-bottom: var(--spacing-3); }
.my-4 { margin-top: var(--spacing-4); margin-bottom: var(--spacing-4); }
.my-6 { margin-top: var(--spacing-6); margin-bottom: var(--spacing-6); }
.my-8 { margin-top: var(--spacing-8); margin-bottom: var(--spacing-8); }
.my-12 { margin-top: var(--spacing-12); margin-bottom: var(--spacing-12); }
.my-16 { margin-top: var(--spacing-16); margin-bottom: var(--spacing-16); }
.my-20 { margin-top: var(--spacing-20); margin-bottom: var(--spacing-20); }

/* Margin Top */
.mt-1 { margin-top: var(--spacing-1); }
.mt-2 { margin-top: var(--spacing-2); }
.mt-3 { margin-top: var(--spacing-3); }
.mt-4 { margin-top: var(--spacing-4); }
.mt-6 { margin-top: var(--spacing-6); }
.mt-8 { margin-top: var(--spacing-8); }
.mt-12 { margin-top: var(--spacing-12); }
.mt-16 { margin-top: var(--spacing-16); }
.mt-20 { margin-top: var(--spacing-20); }

/* Margin Bottom */
.mb-1 { margin-bottom: var(--spacing-1); }
.mb-2 { margin-bottom: var(--spacing-2); }
.mb-3 { margin-bottom: var(--spacing-3); }
.mb-4 { margin-bottom: var(--spacing-4); }
.mb-6 { margin-bottom: var(--spacing-6); }
.mb-8 { margin-bottom: var(--spacing-8); }
.mb-12 { margin-bottom: var(--spacing-12); }
.mb-16 { margin-bottom: var(--spacing-16); }
.mb-20 { margin-bottom: var(--spacing-20); }

/* Padding Utilities (Extended) */
.p-1 { padding: var(--spacing-1); }
.p-2 { padding: var(--spacing-2); }
.p-3 { padding: var(--spacing-3); }
.p-5 { padding: var(--spacing-5); }
.p-10 { padding: var(--spacing-10); }
.p-12 { padding: var(--spacing-12); }
.p-16 { padding: var(--spacing-16); }
.p-20 { padding: var(--spacing-20); }
.p-24 { padding: var(--spacing-24); }

/* Padding X-axis */
.px-1 { padding-left: var(--spacing-1); padding-right: var(--spacing-1); }
.px-2 { padding-left: var(--spacing-2); padding-right: var(--spacing-2); }
.px-3 { padding-left: var(--spacing-3); padding-right: var(--spacing-3); }
.px-5 { padding-left: var(--spacing-5); padding-right: var(--spacing-5); }
.px-6 { padding-left: var(--spacing-6); padding-right: var(--spacing-6); }
.px-8 { padding-left: var(--spacing-8); padding-right: var(--spacing-8); }
.px-12 { padding-left: var(--spacing-12); padding-right: var(--spacing-12); }

/* Padding Y-axis */
.py-1 { padding-top: var(--spacing-1); padding-bottom: var(--spacing-1); }
.py-2 { padding-top: var(--spacing-2); padding-bottom: var(--spacing-2); }
.py-3 { padding-top: var(--spacing-3); padding-bottom: var(--spacing-3); }
.py-5 { padding-top: var(--spacing-5); padding-bottom: var(--spacing-5); }
.py-6 { padding-top: var(--spacing-6); padding-bottom: var(--spacing-6); }
.py-8 { padding-top: var(--spacing-8); padding-bottom: var(--spacing-8); }
.py-12 { padding-top: var(--spacing-12); padding-bottom: var(--spacing-12); }
.py-16 { padding-top: var(--spacing-16); padding-bottom: var(--spacing-16); }
.py-20 { padding-top: var(--spacing-20); padding-bottom: var(--spacing-20); }

/* ==========================================================================
   Background and Border Utilities
   ========================================================================== */

/* Background Colors */
.bg-primary { background-color: var(--color-primary); }
.bg-secondary { background-color: var(--color-secondary); }
.bg-success { background-color: var(--color-success); }
.bg-warning { background-color: var(--color-warning); }
.bg-error { background-color: var(--color-error); }
.bg-info { background-color: var(--color-info); }
.bg-surface { background-color: var(--color-surface); }
.bg-surface-elevated { background-color: var(--color-surface-elevated); }
.bg-white { background-color: white; }
.bg-black { background-color: black; }
.bg-transparent { background-color: transparent; }

/* Background Gradients */
.bg-gradient-primary {
  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-light) 100%);
}

.bg-gradient-secondary {
  background: linear-gradient(135deg, var(--color-secondary) 0%, var(--color-secondary-light) 100%);
}

.bg-gradient-to-r {
  background: linear-gradient(to right, var(--color-primary), var(--color-secondary));
}

.bg-gradient-to-b {
  background: linear-gradient(to bottom, var(--color-primary), var(--color-primary-dark));
}

/* Border Utilities */
.border { border: var(--border-width-1) solid var(--color-border); }
.border-2 { border: var(--border-width-2) solid var(--color-border); }
.border-4 { border: var(--border-width-4) solid var(--color-border); }
.border-0 { border: 0; }

.border-t { border-top: var(--border-width-1) solid var(--color-border); }
.border-r { border-right: var(--border-width-1) solid var(--color-border); }
.border-b { border-bottom: var(--border-width-1) solid var(--color-border); }
.border-l { border-left: var(--border-width-1) solid var(--color-border); }

/* Border Colors */
.border-primary { border-color: var(--color-primary); }
.border-secondary { border-color: var(--color-secondary); }
.border-success { border-color: var(--color-success); }
.border-warning { border-color: var(--color-warning); }
.border-error { border-color: var(--color-error); }
.border-transparent { border-color: transparent; }

/* Border Radius (Extended) */
.rounded-none { border-radius: var(--radius-none); }
.rounded-sm { border-radius: var(--radius-sm); }
.rounded-2xl { border-radius: var(--radius-2xl); }
.rounded-3xl { border-radius: var(--radius-3xl); }

.rounded-t { border-top-left-radius: var(--radius-base); border-top-right-radius: var(--radius-base); }
.rounded-r { border-top-right-radius: var(--radius-base); border-bottom-right-radius: var(--radius-base); }
.rounded-b { border-bottom-left-radius: var(--radius-base); border-bottom-right-radius: var(--radius-base); }
.rounded-l { border-top-left-radius: var(--radius-base); border-bottom-left-radius: var(--radius-base); }

/* ==========================================================================
   Flexbox and Grid Utilities (Extended)
   ========================================================================== */

/* Flex Grow/Shrink */
.flex-grow { flex-grow: 1; }
.flex-grow-0 { flex-grow: 0; }
.flex-shrink { flex-shrink: 1; }
.flex-shrink-0 { flex-shrink: 0; }

/* Align Self */
.self-auto { align-self: auto; }
.self-start { align-self: flex-start; }
.self-center { align-self: center; }
.self-end { align-self: flex-end; }
.self-stretch { align-self: stretch; }

/* Order */
.order-1 { order: 1; }
.order-2 { order: 2; }
.order-3 { order: 3; }
.order-first { order: -9999; }
.order-last { order: 9999; }
.order-none { order: 0; }

/* Grid Utilities (Extended) */
.grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }
.grid-cols-7 { grid-template-columns: repeat(7, minmax(0, 1fr)); }
.grid-cols-8 { grid-template-columns: repeat(8, minmax(0, 1fr)); }
.grid-cols-9 { grid-template-columns: repeat(9, minmax(0, 1fr)); }
.grid-cols-10 { grid-template-columns: repeat(10, minmax(0, 1fr)); }
.grid-cols-11 { grid-template-columns: repeat(11, minmax(0, 1fr)); }

/* Grid Column Span */
.col-span-1 { grid-column: span 1 / span 1; }
.col-span-2 { grid-column: span 2 / span 2; }
.col-span-3 { grid-column: span 3 / span 3; }
.col-span-4 { grid-column: span 4 / span 4; }
.col-span-5 { grid-column: span 5 / span 5; }
.col-span-6 { grid-column: span 6 / span 6; }
.col-span-full { grid-column: 1 / -1; }

/* Grid Row Span */
.row-span-1 { grid-row: span 1 / span 1; }
.row-span-2 { grid-row: span 2 / span 2; }
.row-span-3 { grid-row: span 3 / span 3; }
.row-span-4 { grid-row: span 4 / span 4; }
.row-span-full { grid-row: 1 / -1; }

/* Gap Utilities (Extended) */
.gap-0 { gap: 0; }
.gap-0-5 { gap: var(--spacing-0-5); }
.gap-1-5 { gap: var(--spacing-1-5); }
.gap-5 { gap: var(--spacing-5); }
.gap-10 { gap: var(--spacing-10); }
.gap-12 { gap: var(--spacing-12); }
.gap-16 { gap: var(--spacing-16); }
.gap-20 { gap: var(--spacing-20); }

.gap-x-1 { column-gap: var(--spacing-1); }
.gap-x-2 { column-gap: var(--spacing-2); }
.gap-x-4 { column-gap: var(--spacing-4); }
.gap-x-6 { column-gap: var(--spacing-6); }
.gap-x-8 { column-gap: var(--spacing-8); }

.gap-y-1 { row-gap: var(--spacing-1); }
.gap-y-2 { row-gap: var(--spacing-2); }
.gap-y-4 { row-gap: var(--spacing-4); }
.gap-y-6 { row-gap: var(--spacing-6); }
.gap-y-8 { row-gap: var(--spacing-8); }

/* ==========================================================================
   Width and Height Utilities
   ========================================================================== */

/* Width */
.w-auto { width: auto; }
.w-full { width: 100%; }
.w-screen { width: 100vw; }
.w-min { width: min-content; }
.w-max { width: max-content; }
.w-fit { width: fit-content; }

.w-1\\/2 { width: 50%; }
.w-1\\/3 { width: 33.333333%; }
.w-2\\/3 { width: 66.666667%; }
.w-1\\/4 { width: 25%; }
.w-3\\/4 { width: 75%; }
.w-1\\/5 { width: 20%; }
.w-2\\/5 { width: 40%; }
.w-3\\/5 { width: 60%; }
.w-4\\/5 { width: 80%; }

/* Height */
.h-auto { height: auto; }
.h-full { height: 100%; }
.h-screen { height: 100vh; }
.h-min { height: min-content; }
.h-max { height: max-content; }
.h-fit { height: fit-content; }

.h-1\\/2 { height: 50%; }
.h-1\\/3 { height: 33.333333%; }
.h-2\\/3 { height: 66.666667%; }
.h-1\\/4 { height: 25%; }
.h-3\\/4 { height: 75%; }

/* Min/Max Width */
.min-w-0 { min-width: 0px; }
.min-w-full { min-width: 100%; }
.min-w-min { min-width: min-content; }
.min-w-max { min-width: max-content; }

.max-w-none { max-width: none; }
.max-w-xs { max-width: 20rem; }
.max-w-sm { max-width: 24rem; }
.max-w-md { max-width: 28rem; }
.max-w-lg { max-width: 32rem; }
.max-w-xl { max-width: 36rem; }
.max-w-2xl { max-width: 42rem; }
.max-w-3xl { max-width: 48rem; }
.max-w-4xl { max-width: 56rem; }
.max-w-5xl { max-width: 64rem; }
.max-w-6xl { max-width: 72rem; }
.max-w-7xl { max-width: 80rem; }
.max-w-full { max-width: 100%; }
.max-w-screen-sm { max-width: var(--breakpoint-sm); }
.max-w-screen-md { max-width: var(--breakpoint-md); }
.max-w-screen-lg { max-width: var(--breakpoint-lg); }
.max-w-screen-xl { max-width: var(--breakpoint-xl); }

/* Min/Max Height */
.min-h-0 { min-height: 0px; }
.min-h-full { min-height: 100%; }
.min-h-screen { min-height: 100vh; }

.max-h-full { max-height: 100%; }
.max-h-screen { max-height: 100vh; }

/* ==========================================================================
   Animation and Transform Utilities
   ========================================================================== */

/* Transform */
.transform { transform: translateX(var(--tw-translate-x, 0)) translateY(var(--tw-translate-y, 0)) rotate(var(--tw-rotate, 0)) skewX(var(--tw-skew-x, 0)) skewY(var(--tw-skew-y, 0)) scaleX(var(--tw-scale-x, 1)) scaleY(var(--tw-scale-y, 1)); }
.transform-none { transform: none; }

/* Scale */
.scale-0 { transform: scale(0); }
.scale-50 { transform: scale(0.5); }
.scale-75 { transform: scale(0.75); }
.scale-90 { transform: scale(0.9); }
.scale-95 { transform: scale(0.95); }
.scale-100 { transform: scale(1); }
.scale-105 { transform: scale(1.05); }
.scale-110 { transform: scale(1.1); }
.scale-125 { transform: scale(1.25); }
.scale-150 { transform: scale(1.5); }

/* Rotate */
.rotate-0 { transform: rotate(0deg); }
.rotate-1 { transform: rotate(1deg); }
.rotate-2 { transform: rotate(2deg); }
.rotate-3 { transform: rotate(3deg); }
.rotate-6 { transform: rotate(6deg); }
.rotate-12 { transform: rotate(12deg); }
.rotate-45 { transform: rotate(45deg); }
.rotate-90 { transform: rotate(90deg); }
.rotate-180 { transform: rotate(180deg); }

/* Translate */
.translate-x-0 { transform: translateX(0px); }
.translate-x-1 { transform: translateX(var(--spacing-1)); }
.translate-x-2 { transform: translateX(var(--spacing-2)); }
.translate-x-4 { transform: translateX(var(--spacing-4)); }
.translate-x-8 { transform: translateX(var(--spacing-8)); }

.translate-y-0 { transform: translateY(0px); }
.translate-y-1 { transform: translateY(var(--spacing-1)); }
.translate-y-2 { transform: translateY(var(--spacing-2)); }
.translate-y-4 { transform: translateY(var(--spacing-4)); }
.translate-y-8 { transform: translateY(var(--spacing-8)); }

/* Animation Classes */
.animate-spin {
  animation: spin 1s linear infinite;
}

.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.animate-bounce {
  animation: bounce 1s infinite;
}

.animate-fade-in {
  animation: fadeIn 0.5s ease-in-out;
}

.animate-slide-in-up {
  animation: slideInUp 0.5s ease-out;
}

.animate-slide-in-down {
  animation: slideInDown 0.5s ease-out;
}

.animate-slide-in-left {
  animation: slideInLeft 0.5s ease-out;
}

.animate-slide-in-right {
  animation: slideInRight 0.5s ease-out;
}

@keyframes ping {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: .5;
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideInUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideInDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideInLeft {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* ==========================================================================
   Component-Specific Styles
   ========================================================================== */

/* Hero Section */
.hero {
  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-light) 100%);
  color: white;
  padding: var(--spacing-32) 0 var(--spacing-20);
  margin-top: 70px; /* Account for fixed navigation */
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1;
}

.hero-actions {
  display: flex;
  gap: var(--spacing-4);
  justify-content: center;
  flex-wrap: wrap;
}

/* Stats Section */
.stats-section {
  padding: var(--spacing-20) 0;
  background-color: var(--color-surface);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--spacing-8);
  text-align: center;
}

.stat-item {
  padding: var(--spacing-6);
  background: var(--color-surface-elevated);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-base);
}

.stat-item:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-md);
}

.stat-value {
  font-size: var(--font-size-4xl);
  font-weight: var(--font-weight-extrabold);
  color: var(--color-primary);
  margin-bottom: var(--spacing-2);
  line-height: var(--line-height-none);
}

.stat-label {
  font-size: var(--font-size-lg);
  color: var(--color-text-secondary);
  font-weight: var(--font-weight-medium);
  text-transform: uppercase;
  letter-spacing: var(--letter-spacing-wide);
}

/* Courses Overview */
.courses-overview {
  padding: var(--spacing-20) 0;
}

.section-title {
  text-align: center;
  font-size: var(--font-size-4xl);
  margin-bottom: var(--spacing-12);
  color: var(--color-text);
  font-weight: var(--font-weight-extrabold);
}

.courses-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--spacing-8);
}

/* Footer */
.footer {
  background-color: var(--color-primary);
  color: white;
  padding: var(--spacing-16) 0 var(--spacing-8);
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--spacing-8);
  margin-bottom: var(--spacing-8);
}

.footer-section h3,
.footer-section h4 {
  margin-bottom: var(--spacing-4);
  color: white;
  font-weight: var(--font-weight-bold);
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: var(--spacing-2);
}

.footer-section ul li a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.footer-section ul li a:hover {
  color: white;
  text-decoration: underline;
}

.footer-bottom {
  text-align: center;
  padding-top: var(--spacing-8);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.8);
}

/* Loading Overlay */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-modal);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--color-border);
  border-top: 4px solid var(--color-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Toast Notifications */
.toast {
  position: fixed;
  top: var(--spacing-4);
  right: var(--spacing-4);
  background-color: var(--color-surface-elevated);
  color: var(--color-text);
  padding: var(--spacing-4) var(--spacing-6);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--color-border);
  z-index: var(--z-toast);
  animation: slideInRight 0.3s ease-out;
  max-width: 400px;
  min-width: 300px;
}

.toast.success {
  border-left: 4px solid var(--color-success);
}

.toast.error {
  border-left: 4px solid var(--color-error);
}

.toast.warning {
  border-left: 4px solid var(--color-warning);
}

.toast.info {
  border-left: 4px solid var(--color-info);
}

/* Form Styles */
.form-group {
  margin-bottom: var(--spacing-4);
}

.form-label {
  display: block;
  margin-bottom: var(--spacing-2);
  font-weight: var(--font-weight-medium);
  color: var(--color-text);
}

.form-input {
  width: 100%;
  padding: var(--spacing-3) var(--spacing-4);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background-color: var(--color-surface);
  color: var(--color-text);
  font-size: var(--font-size-base);
  transition: all var(--transition-fast);
}

.form-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb), 0.1);
}

.form-input.error {
  border-color: var(--color-error);
}

.form-input.success {
  border-color: var(--color-success);
}

.form-error {
  color: var(--color-error);
  font-size: var(--font-size-sm);
  margin-top: var(--spacing-1);
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.form-success {
  color: var(--color-success);
  font-size: var(--font-size-sm);
  margin-top: var(--spacing-1);
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

/* Button Sizes */
.btn-xs {
  padding: var(--spacing-1) var(--spacing-2);
  font-size: var(--font-size-xs);
}

.btn-sm {
  padding: var(--spacing-2) var(--spacing-4);
  font-size: var(--font-size-sm);
}

.btn-lg {
  padding: var(--spacing-4) var(--spacing-8);
  font-size: var(--font-size-lg);
}

.btn-xl {
  padding: var(--spacing-5) var(--spacing-10);
  font-size: var(--font-size-xl);
}

/* Card Component */
.card {
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  transition: all var(--transition-base);
}

.card:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.card-header {
  padding: var(--spacing-6);
  border-bottom: 1px solid var(--color-border);
  background-color: var(--color-surface-elevated);
}

.card-body {
  padding: var(--spacing-6);
}

.card-footer {
  padding: var(--spacing-6);
  border-top: 1px solid var(--color-border);
  background-color: var(--color-surface-elevated);
}

/* Badge Component */
.badge {
  display: inline-flex;
  align-items: center;
  padding: var(--spacing-1) var(--spacing-2);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  border-radius: var(--radius-full);
  text-transform: uppercase;
  letter-spacing: var(--letter-spacing-wide);
}

.badge-primary {
  background-color: var(--color-primary);
  color: white;
}

.badge-secondary {
  background-color: var(--color-secondary);
  color: white;
}

.badge-success {
  background-color: var(--color-success);
  color: white;
}

.badge-warning {
  background-color: var(--color-warning);
  color: white;
}

.badge-error {
  background-color: var(--color-error);
  color: white;
}

.badge-outline {
  background-color: transparent;
  border: 1px solid var(--color-border);
  color: var(--color-text);
}

/* ==========================================================================
   Responsive Design Utilities
   ========================================================================== */

/* Mobile First Responsive Utilities */
@media (min-width: 475px) {
  .xs\\:block { display: block; }
  .xs\\:hidden { display: none; }
  .xs\\:flex { display: flex; }
  .xs\\:grid { display: grid; }
  .xs\\:text-center { text-align: center; }
  .xs\\:text-left { text-align: left; }
}

@media (min-width: 640px) {
  .sm\\:block { display: block; }
  .sm\\:hidden { display: none; }
  .sm\\:flex { display: flex; }
  .sm\\:grid { display: grid; }
  .sm\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .sm\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .sm\\:flex-row { flex-direction: row; }
  .sm\\:flex-col { flex-direction: column; }
  .sm\\:text-left { text-align: left; }
  .sm\\:text-center { text-align: center; }
  .sm\\:text-right { text-align: right; }
  .sm\\:p-6 { padding: var(--spacing-6); }
  .sm\\:px-6 { padding-left: var(--spacing-6); padding-right: var(--spacing-6); }
  .sm\\:py-8 { padding-top: var(--spacing-8); padding-bottom: var(--spacing-8); }
}

@media (min-width: 768px) {
  .md\\:block { display: block; }
  .md\\:hidden { display: none; }
  .md\\:flex { display: flex; }
  .md\\:grid { display: grid; }
  .md\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .md\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .md\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .md\\:flex-row { flex-direction: row; }
  .md\\:flex-col { flex-direction: column; }
  .md\\:text-left { text-align: left; }
  .md\\:text-center { text-align: center; }
  .md\\:text-right { text-align: right; }
  .md\\:text-lg { font-size: var(--font-size-lg); }
  .md\\:text-xl { font-size: var(--font-size-xl); }
  .md\\:text-2xl { font-size: var(--font-size-2xl); }
  .md\\:text-3xl { font-size: var(--font-size-3xl); }
  .md\\:p-8 { padding: var(--spacing-8); }
  .md\\:px-8 { padding-left: var(--spacing-8); padding-right: var(--spacing-8); }
  .md\\:py-12 { padding-top: var(--spacing-12); padding-bottom: var(--spacing-12); }
}

@media (min-width: 1024px) {
  .lg\\:block { display: block; }
  .lg\\:hidden { display: none; }
  .lg\\:flex { display: flex; }
  .lg\\:grid { display: grid; }
  .lg\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .lg\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .lg\\:grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }
  .lg\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }
  .lg\\:flex-row { flex-direction: row; }
  .lg\\:flex-col { flex-direction: column; }
  .lg\\:text-left { text-align: left; }
  .lg\\:text-center { text-align: center; }
  .lg\\:text-right { text-align: right; }
  .lg\\:text-xl { font-size: var(--font-size-xl); }
  .lg\\:text-2xl { font-size: var(--font-size-2xl); }
  .lg\\:text-3xl { font-size: var(--font-size-3xl); }
  .lg\\:text-4xl { font-size: var(--font-size-4xl); }
  .lg\\:p-12 { padding: var(--spacing-12); }
  .lg\\:px-12 { padding-left: var(--spacing-12); padding-right: var(--spacing-12); }
  .lg\\:py-16 { padding-top: var(--spacing-16); padding-bottom: var(--spacing-16); }
}

@media (min-width: 1280px) {
  .xl\\:block { display: block; }
  .xl\\:hidden { display: none; }
  .xl\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .xl\\:grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }
  .xl\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }
  .xl\\:text-2xl { font-size: var(--font-size-2xl); }
  .xl\\:text-3xl { font-size: var(--font-size-3xl); }
  .xl\\:text-4xl { font-size: var(--font-size-4xl); }
  .xl\\:text-5xl { font-size: var(--font-size-5xl); }
}

@media (min-width: 1536px) {
  .2xl\\:block { display: block; }
  .2xl\\:hidden { display: none; }
  .2xl\\:grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }
  .2xl\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }
  .2xl\\:text-3xl { font-size: var(--font-size-3xl); }
  .2xl\\:text-4xl { font-size: var(--font-size-4xl); }
  .2xl\\:text-5xl { font-size: var(--font-size-5xl); }
  .2xl\\:text-6xl { font-size: var(--font-size-6xl); }
}

/* ==========================================================================
   Mobile Responsive Adjustments
   ========================================================================== */

@media (max-width: 768px) {
  .hero {
    padding: var(--spacing-20) 0 var(--spacing-16);
  }
  
  .hero-title {
    font-size: var(--font-size-3xl);
  }
  
  .hero-subtitle {
    font-size: var(--font-size-lg);
  }
  
  .hero-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--spacing-4);
  }
  
  .courses-grid {
    grid-template-columns: 1fr;
  }
  
  .section-title {
    font-size: var(--font-size-3xl);
  }
  
  .toast {
    left: var(--spacing-4);
    right: var(--spacing-4);
    max-width: none;
  }
}

@media (max-width: 480px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .stat-value {
    font-size: var(--font-size-3xl);
  }
  
  .hero-title {
    font-size: var(--font-size-2xl);
  }
  
  .section-title {
    font-size: var(--font-size-2xl);
  }
  

}

/* ==========================================================================
   Print Styles
   ========================================================================== */

@media print {
  .no-print {
    display: none !important;
  }
  
  .hero,
  .navigation,
  .footer,
  .toast,
  .loading-overlay {
    display: none !important;
  }
  
  * {
    background: white !important;
    color: black !important;
    box-shadow: none !important;
  }
  
  a {
    text-decoration: underline !important;
  }
  
  .container {
    max-width: none !important;
    padding: 0 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/styles/utilities.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;;+EAE+E;;AAE/E,yBAAyB;AACzB;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;+EAE+E;;AAE/E,0BAA0B;AAC1B,YAAY,+BAA+B,EAAE;AAC7C,YAAY,+BAA+B,EAAE;AAC7C,YAAY,+BAA+B,EAAE;AAC7C,YAAY,+BAA+B,EAAE;AAC7C,YAAY,+BAA+B,EAAE;AAC7C,YAAY,+BAA+B,EAAE;;AAE7C,4BAA4B;AAC5B,aAAa,oCAAoC,EAAE;AACnD,mBAAmB,0CAA0C,EAAE;AAC/D,kBAAkB,yCAAyC,EAAE;AAC7D,cAAc,qCAAqC,EAAE;;AAErD,iBAAiB;AACjB,gBAAgB,oCAAoC,EAAE;AACtD,iBAAiB,qCAAqC,EAAE;AACxD,gBAAgB,oCAAoC,EAAE;AACtD,kBAAkB,sCAAsC,EAAE;AAC1D,mBAAmB,uCAAuC,EAAE;AAC5D,iBAAiB,qCAAqC,EAAE;;AAExD,mBAAmB;AACnB,oBAAoB,6CAA6C,EAAE;AACnE,kBAAkB,2CAA2C,EAAE;AAC/D,mBAAmB,4CAA4C,EAAE;AACjE,iBAAiB,0CAA0C,EAAE;AAC7D,kBAAkB,2CAA2C,EAAE;AAC/D,mBAAmB,4CAA4C,EAAE;;AAEjE,2BAA2B;AAC3B,gBAAgB,2BAA2B,EAAE;AAC7C,gBAAgB,2BAA2B,EAAE;AAC7C,cAAc,yBAAyB,EAAE;AACzC,aAAa,wBAAwB,EAAE;AACvC,cAAc,YAAY,EAAE;AAC5B,cAAc,YAAY,EAAE;;AAE5B,mBAAmB;AACnB,kBAAkB,yBAAyB,EAAE;AAC7C,kBAAkB,yBAAyB,EAAE;AAC7C,mBAAmB,0BAA0B,EAAE;AAC/C;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;+EAE+E;;AAE/E,qBAAqB;AACrB,OAAO,wBAAwB,EAAE;AACjC,OAAO,wBAAwB,EAAE;AACjC,OAAO,wBAAwB,EAAE;AACjC,OAAO,wBAAwB,EAAE;AACjC,OAAO,wBAAwB,EAAE;AACjC,OAAO,wBAAwB,EAAE;AACjC,OAAO,wBAAwB,EAAE;AACjC,QAAQ,yBAAyB,EAAE;AACnC,QAAQ,yBAAyB,EAAE;AACnC,QAAQ,yBAAyB,EAAE;AACnC,QAAQ,yBAAyB,EAAE;AACnC,QAAQ,yBAAyB,EAAE;AACnC,QAAQ,yBAAyB,EAAE;;AAEnC,kBAAkB;AAClB,QAAQ,6BAA6B,EAAE,8BAA8B,EAAE;AACvE,QAAQ,6BAA6B,EAAE,8BAA8B,EAAE;AACvE,QAAQ,6BAA6B,EAAE,8BAA8B,EAAE;AACvE,QAAQ,6BAA6B,EAAE,8BAA8B,EAAE;AACvE,QAAQ,6BAA6B,EAAE,8BAA8B,EAAE;AACvE,QAAQ,6BAA6B,EAAE,8BAA8B,EAAE;;AAEvE,kBAAkB;AAClB,QAAQ,4BAA4B,EAAE,+BAA+B,EAAE;AACvE,QAAQ,4BAA4B,EAAE,+BAA+B,EAAE;AACvE,QAAQ,4BAA4B,EAAE,+BAA+B,EAAE;AACvE,QAAQ,4BAA4B,EAAE,+BAA+B,EAAE;AACvE,QAAQ,4BAA4B,EAAE,+BAA+B,EAAE;AACvE,QAAQ,4BAA4B,EAAE,+BAA+B,EAAE;AACvE,SAAS,6BAA6B,EAAE,gCAAgC,EAAE;AAC1E,SAAS,6BAA6B,EAAE,gCAAgC,EAAE;AAC1E,SAAS,6BAA6B,EAAE,gCAAgC,EAAE;;AAE1E,eAAe;AACf,QAAQ,4BAA4B,EAAE;AACtC,QAAQ,4BAA4B,EAAE;AACtC,QAAQ,4BAA4B,EAAE;AACtC,QAAQ,4BAA4B,EAAE;AACtC,QAAQ,4BAA4B,EAAE;AACtC,QAAQ,4BAA4B,EAAE;AACtC,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;;AAExC,kBAAkB;AAClB,QAAQ,+BAA+B,EAAE;AACzC,QAAQ,+BAA+B,EAAE;AACzC,QAAQ,+BAA+B,EAAE;AACzC,QAAQ,+BAA+B,EAAE;AACzC,QAAQ,+BAA+B,EAAE;AACzC,QAAQ,+BAA+B,EAAE;AACzC,SAAS,gCAAgC,EAAE;AAC3C,SAAS,gCAAgC,EAAE;AAC3C,SAAS,gCAAgC,EAAE;;AAE3C,iCAAiC;AACjC,OAAO,yBAAyB,EAAE;AAClC,OAAO,yBAAyB,EAAE;AAClC,OAAO,yBAAyB,EAAE;AAClC,OAAO,yBAAyB,EAAE;AAClC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;;AAEpC,mBAAmB;AACnB,QAAQ,8BAA8B,EAAE,+BAA+B,EAAE;AACzE,QAAQ,8BAA8B,EAAE,+BAA+B,EAAE;AACzE,QAAQ,8BAA8B,EAAE,+BAA+B,EAAE;AACzE,QAAQ,8BAA8B,EAAE,+BAA+B,EAAE;AACzE,QAAQ,8BAA8B,EAAE,+BAA+B,EAAE;AACzE,QAAQ,8BAA8B,EAAE,+BAA+B,EAAE;AACzE,SAAS,+BAA+B,EAAE,gCAAgC,EAAE;;AAE5E,mBAAmB;AACnB,QAAQ,6BAA6B,EAAE,gCAAgC,EAAE;AACzE,QAAQ,6BAA6B,EAAE,gCAAgC,EAAE;AACzE,QAAQ,6BAA6B,EAAE,gCAAgC,EAAE;AACzE,QAAQ,6BAA6B,EAAE,gCAAgC,EAAE;AACzE,QAAQ,6BAA6B,EAAE,gCAAgC,EAAE;AACzE,QAAQ,6BAA6B,EAAE,gCAAgC,EAAE;AACzE,SAAS,8BAA8B,EAAE,iCAAiC,EAAE;AAC5E,SAAS,8BAA8B,EAAE,iCAAiC,EAAE;AAC5E,SAAS,8BAA8B,EAAE,iCAAiC,EAAE;;AAE5E;;+EAE+E;;AAE/E,sBAAsB;AACtB,cAAc,sCAAsC,EAAE;AACtD,gBAAgB,wCAAwC,EAAE;AAC1D,cAAc,sCAAsC,EAAE;AACtD,cAAc,sCAAsC,EAAE;AACtD,YAAY,oCAAoC,EAAE;AAClD,WAAW,mCAAmC,EAAE;AAChD,cAAc,sCAAsC,EAAE;AACtD,uBAAuB,+CAA+C,EAAE;AACxE,YAAY,uBAAuB,EAAE;AACrC,YAAY,uBAAuB,EAAE;AACrC,kBAAkB,6BAA6B,EAAE;;AAEjD,yBAAyB;AACzB;EACE,6FAA6F;AAC/F;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,uFAAuF;AACzF;;AAEA,qBAAqB;AACrB,UAAU,uDAAuD,EAAE;AACnE,YAAY,uDAAuD,EAAE;AACrE,YAAY,uDAAuD,EAAE;AACrE,YAAY,SAAS,EAAE;;AAEvB,YAAY,2DAA2D,EAAE;AACzE,YAAY,6DAA6D,EAAE;AAC3E,YAAY,8DAA8D,EAAE;AAC5E,YAAY,4DAA4D,EAAE;;AAE1E,kBAAkB;AAClB,kBAAkB,kCAAkC,EAAE;AACtD,oBAAoB,oCAAoC,EAAE;AAC1D,kBAAkB,kCAAkC,EAAE;AACtD,kBAAkB,kCAAkC,EAAE;AACtD,gBAAgB,gCAAgC,EAAE;AAClD,sBAAsB,yBAAyB,EAAE;;AAEjD,6BAA6B;AAC7B,gBAAgB,iCAAiC,EAAE;AACnD,cAAc,+BAA+B,EAAE;AAC/C,eAAe,gCAAgC,EAAE;AACjD,eAAe,gCAAgC,EAAE;;AAEjD,aAAa,0CAA0C,EAAE,2CAA2C,EAAE;AACtG,aAAa,2CAA2C,EAAE,8CAA8C,EAAE;AAC1G,aAAa,6CAA6C,EAAE,8CAA8C,EAAE;AAC5G,aAAa,0CAA0C,EAAE,6CAA6C,EAAE;;AAExG;;+EAE+E;;AAE/E,qBAAqB;AACrB,aAAa,YAAY,EAAE;AAC3B,eAAe,YAAY,EAAE;AAC7B,eAAe,cAAc,EAAE;AAC/B,iBAAiB,cAAc,EAAE;;AAEjC,eAAe;AACf,aAAa,gBAAgB,EAAE;AAC/B,cAAc,sBAAsB,EAAE;AACtC,eAAe,kBAAkB,EAAE;AACnC,YAAY,oBAAoB,EAAE;AAClC,gBAAgB,mBAAmB,EAAE;;AAErC,UAAU;AACV,WAAW,QAAQ,EAAE;AACrB,WAAW,QAAQ,EAAE;AACrB,WAAW,QAAQ,EAAE;AACrB,eAAe,YAAY,EAAE;AAC7B,cAAc,WAAW,EAAE;AAC3B,cAAc,QAAQ,EAAE;;AAExB,8BAA8B;AAC9B,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,gBAAgB,iDAAiD,EAAE;AACnE,gBAAgB,iDAAiD,EAAE;;AAEnE,qBAAqB;AACrB,cAAc,4BAA4B,EAAE;AAC5C,cAAc,4BAA4B,EAAE;AAC5C,cAAc,4BAA4B,EAAE;AAC5C,cAAc,4BAA4B,EAAE;AAC5C,cAAc,4BAA4B,EAAE;AAC5C,cAAc,4BAA4B,EAAE;AAC5C,iBAAiB,mBAAmB,EAAE;;AAEtC,kBAAkB;AAClB,cAAc,yBAAyB,EAAE;AACzC,cAAc,yBAAyB,EAAE;AACzC,cAAc,yBAAyB,EAAE;AACzC,cAAc,yBAAyB,EAAE;AACzC,iBAAiB,gBAAgB,EAAE;;AAEnC,6BAA6B;AAC7B,SAAS,MAAM,EAAE;AACjB,WAAW,uBAAuB,EAAE;AACpC,WAAW,uBAAuB,EAAE;AACpC,SAAS,qBAAqB,EAAE;AAChC,UAAU,sBAAsB,EAAE;AAClC,UAAU,sBAAsB,EAAE;AAClC,UAAU,sBAAsB,EAAE;AAClC,UAAU,sBAAsB,EAAE;;AAElC,WAAW,4BAA4B,EAAE;AACzC,WAAW,4BAA4B,EAAE;AACzC,WAAW,4BAA4B,EAAE;AACzC,WAAW,4BAA4B,EAAE;AACzC,WAAW,4BAA4B,EAAE;;AAEzC,WAAW,yBAAyB,EAAE;AACtC,WAAW,yBAAyB,EAAE;AACtC,WAAW,yBAAyB,EAAE;AACtC,WAAW,yBAAyB,EAAE;AACtC,WAAW,yBAAyB,EAAE;;AAEtC;;+EAE+E;;AAE/E,UAAU;AACV,UAAU,WAAW,EAAE;AACvB,UAAU,WAAW,EAAE;AACvB,YAAY,YAAY,EAAE;AAC1B,SAAS,kBAAkB,EAAE;AAC7B,SAAS,kBAAkB,EAAE;AAC7B,SAAS,kBAAkB,EAAE;;AAE7B,UAAU,UAAU,EAAE;AACtB,UAAU,iBAAiB,EAAE;AAC7B,UAAU,iBAAiB,EAAE;AAC7B,UAAU,UAAU,EAAE;AACtB,UAAU,UAAU,EAAE;AACtB,UAAU,UAAU,EAAE;AACtB,UAAU,UAAU,EAAE;AACtB,UAAU,UAAU,EAAE;AACtB,UAAU,UAAU,EAAE;;AAEtB,WAAW;AACX,UAAU,YAAY,EAAE;AACxB,UAAU,YAAY,EAAE;AACxB,YAAY,aAAa,EAAE;AAC3B,SAAS,mBAAmB,EAAE;AAC9B,SAAS,mBAAmB,EAAE;AAC9B,SAAS,mBAAmB,EAAE;;AAE9B,UAAU,WAAW,EAAE;AACvB,UAAU,kBAAkB,EAAE;AAC9B,UAAU,kBAAkB,EAAE;AAC9B,UAAU,WAAW,EAAE;AACvB,UAAU,WAAW,EAAE;;AAEvB,kBAAkB;AAClB,WAAW,cAAc,EAAE;AAC3B,cAAc,eAAe,EAAE;AAC/B,aAAa,sBAAsB,EAAE;AACrC,aAAa,sBAAsB,EAAE;;AAErC,cAAc,eAAe,EAAE;AAC/B,YAAY,gBAAgB,EAAE;AAC9B,YAAY,gBAAgB,EAAE;AAC9B,YAAY,gBAAgB,EAAE;AAC9B,YAAY,gBAAgB,EAAE;AAC9B,YAAY,gBAAgB,EAAE;AAC9B,aAAa,gBAAgB,EAAE;AAC/B,aAAa,gBAAgB,EAAE;AAC/B,aAAa,gBAAgB,EAAE;AAC/B,aAAa,gBAAgB,EAAE;AAC/B,aAAa,gBAAgB,EAAE;AAC/B,aAAa,gBAAgB,EAAE;AAC/B,cAAc,eAAe,EAAE;AAC/B,mBAAmB,+BAA+B,EAAE;AACpD,mBAAmB,+BAA+B,EAAE;AACpD,mBAAmB,+BAA+B,EAAE;AACpD,mBAAmB,+BAA+B,EAAE;;AAEpD,mBAAmB;AACnB,WAAW,eAAe,EAAE;AAC5B,cAAc,gBAAgB,EAAE;AAChC,gBAAgB,iBAAiB,EAAE;;AAEnC,cAAc,gBAAgB,EAAE;AAChC,gBAAgB,iBAAiB,EAAE;;AAEnC;;+EAE+E;;AAE/E,cAAc;AACd,aAAa,gOAAgO,EAAE;AAC/O,kBAAkB,eAAe,EAAE;;AAEnC,UAAU;AACV,WAAW,mBAAmB,EAAE;AAChC,YAAY,qBAAqB,EAAE;AACnC,YAAY,sBAAsB,EAAE;AACpC,YAAY,qBAAqB,EAAE;AACnC,YAAY,sBAAsB,EAAE;AACpC,aAAa,mBAAmB,EAAE;AAClC,aAAa,sBAAsB,EAAE;AACrC,aAAa,qBAAqB,EAAE;AACpC,aAAa,sBAAsB,EAAE;AACrC,aAAa,qBAAqB,EAAE;;AAEpC,WAAW;AACX,YAAY,uBAAuB,EAAE;AACrC,YAAY,uBAAuB,EAAE;AACrC,YAAY,uBAAuB,EAAE;AACrC,YAAY,uBAAuB,EAAE;AACrC,YAAY,uBAAuB,EAAE;AACrC,aAAa,wBAAwB,EAAE;AACvC,aAAa,wBAAwB,EAAE;AACvC,aAAa,wBAAwB,EAAE;AACvC,cAAc,yBAAyB,EAAE;;AAEzC,cAAc;AACd,iBAAiB,0BAA0B,EAAE;AAC7C,iBAAiB,uCAAuC,EAAE;AAC1D,iBAAiB,uCAAuC,EAAE;AAC1D,iBAAiB,uCAAuC,EAAE;AAC1D,iBAAiB,uCAAuC,EAAE;;AAE1D,iBAAiB,0BAA0B,EAAE;AAC7C,iBAAiB,uCAAuC,EAAE;AAC1D,iBAAiB,uCAAuC,EAAE;AAC1D,iBAAiB,uCAAuC,EAAE;AAC1D,iBAAiB,uCAAuC,EAAE;;AAE1D,sBAAsB;AACtB;EACE,kCAAkC;AACpC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,qDAAqD;EACvD;EACA;IACE,wBAAwB;IACxB,qDAAqD;EACvD;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;;+EAE+E;;AAE/E,iBAAiB;AACjB;EACE,6FAA6F;EAC7F,YAAY;EACZ,8CAA8C;EAC9C,gBAAgB,EAAE,iCAAiC;EACnD,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,2BAA2B;EAC3B,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,sCAAsC;EACtC,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA,qBAAqB;AACrB;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,sCAAsC;EACtC,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;EAC/B,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,+CAA+C;EAC/C,wBAAwB;EACxB,0CAA0C;EAC1C,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,qCAAqC;EACrC,+BAA+B;EAC/B,sCAAsC;EACtC,wBAAwB;EACxB,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,yDAAyD;AAC3D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,sCAAsC;EACtC,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,+CAA+C;AACjD;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,8BAA8B;EAC9B,sCAAsC;EACtC,iCAAiC;EACjC,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;;+EAE+E;;AAE/E,sCAAsC;AACtC;EACE,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;EAC7B,YAAY,aAAa,EAAE;EAC3B,YAAY,aAAa,EAAE;EAC3B,mBAAmB,kBAAkB,EAAE;EACvC,iBAAiB,gBAAgB,EAAE;AACrC;;AAEA;EACE,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;EAC7B,YAAY,aAAa,EAAE;EAC3B,YAAY,aAAa,EAAE;EAC3B,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,gBAAgB,mBAAmB,EAAE;EACrC,gBAAgB,sBAAsB,EAAE;EACxC,iBAAiB,gBAAgB,EAAE;EACnC,mBAAmB,kBAAkB,EAAE;EACvC,kBAAkB,iBAAiB,EAAE;EACrC,WAAW,yBAAyB,EAAE;EACtC,YAAY,8BAA8B,EAAE,+BAA+B,EAAE;EAC7E,YAAY,6BAA6B,EAAE,gCAAgC,EAAE;AAC/E;;AAEA;EACE,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;EAC7B,YAAY,aAAa,EAAE;EAC3B,YAAY,aAAa,EAAE;EAC3B,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,gBAAgB,mBAAmB,EAAE;EACrC,gBAAgB,sBAAsB,EAAE;EACxC,iBAAiB,gBAAgB,EAAE;EACnC,mBAAmB,kBAAkB,EAAE;EACvC,kBAAkB,iBAAiB,EAAE;EACrC,eAAe,8BAA8B,EAAE;EAC/C,eAAe,8BAA8B,EAAE;EAC/C,gBAAgB,+BAA+B,EAAE;EACjD,gBAAgB,+BAA+B,EAAE;EACjD,WAAW,yBAAyB,EAAE;EACtC,YAAY,8BAA8B,EAAE,+BAA+B,EAAE;EAC7E,aAAa,8BAA8B,EAAE,iCAAiC,EAAE;AAClF;;AAEA;EACE,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;EAC7B,YAAY,aAAa,EAAE;EAC3B,YAAY,aAAa,EAAE;EAC3B,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,gBAAgB,mBAAmB,EAAE;EACrC,gBAAgB,sBAAsB,EAAE;EACxC,iBAAiB,gBAAgB,EAAE;EACnC,mBAAmB,kBAAkB,EAAE;EACvC,kBAAkB,iBAAiB,EAAE;EACrC,eAAe,8BAA8B,EAAE;EAC/C,gBAAgB,+BAA+B,EAAE;EACjD,gBAAgB,+BAA+B,EAAE;EACjD,gBAAgB,+BAA+B,EAAE;EACjD,YAAY,0BAA0B,EAAE;EACxC,aAAa,+BAA+B,EAAE,gCAAgC,EAAE;EAChF,aAAa,8BAA8B,EAAE,iCAAiC,EAAE;AAClF;;AAEA;EACE,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;EAC7B,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,gBAAgB,+BAA+B,EAAE;EACjD,gBAAgB,+BAA+B,EAAE;EACjD,gBAAgB,+BAA+B,EAAE;EACjD,gBAAgB,+BAA+B,EAAE;AACnD;;AAEA;EACE,cAAc,cAAc,EAAE;EAC9B,eAAe,aAAa,EAAE;EAC9B,oBAAoB,gDAAgD,EAAE;EACtE,oBAAoB,gDAAgD,EAAE;EACtE,iBAAiB,+BAA+B,EAAE;EAClD,iBAAiB,+BAA+B,EAAE;EAClD,iBAAiB,+BAA+B,EAAE;EAClD,iBAAiB,+BAA+B,EAAE;AACpD;;AAEA;;+EAE+E;;AAE/E;EACE;IACE,8CAA8C;EAChD;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC;;;AAGF;;AAEA;;+EAE+E;;AAE/E;EACE;IACE,wBAAwB;EAC1B;;EAEA;;;;;IAKE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;AACF","sourcesContent":["/* Additional Utility Classes and Component Styles */\r\n\r\n/* ==========================================================================\r\n   Layout Utilities\r\n   ========================================================================== */\r\n\r\n/* Container Variations */\r\n.container-fluid {\r\n  width: 100%;\r\n  padding: 0 var(--spacing-4);\r\n}\r\n\r\n.container-narrow {\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n  padding: 0 var(--spacing-4);\r\n}\r\n\r\n.container-wide {\r\n  max-width: 1600px;\r\n  margin: 0 auto;\r\n  padding: 0 var(--spacing-4);\r\n}\r\n\r\n/* Section Spacing */\r\n.section {\r\n  padding: var(--spacing-20) 0;\r\n}\r\n\r\n.section-sm {\r\n  padding: var(--spacing-12) 0;\r\n}\r\n\r\n.section-lg {\r\n  padding: var(--spacing-32) 0;\r\n}\r\n\r\n.section-xl {\r\n  padding: var(--spacing-40) 0;\r\n}\r\n\r\n/* ==========================================================================\r\n   Typography Utilities\r\n   ========================================================================== */\r\n\r\n/* Text Sizes (Extended) */\r\n.text-4xl { font-size: var(--font-size-4xl); }\r\n.text-5xl { font-size: var(--font-size-5xl); }\r\n.text-6xl { font-size: var(--font-size-6xl); }\r\n.text-7xl { font-size: var(--font-size-7xl); }\r\n.text-8xl { font-size: var(--font-size-8xl); }\r\n.text-9xl { font-size: var(--font-size-9xl); }\r\n\r\n/* Font Weights (Extended) */\r\n.font-thin { font-weight: var(--font-weight-thin); }\r\n.font-extralight { font-weight: var(--font-weight-extralight); }\r\n.font-extrabold { font-weight: var(--font-weight-extrabold); }\r\n.font-black { font-weight: var(--font-weight-black); }\r\n\r\n/* Line Heights */\r\n.leading-none { line-height: var(--line-height-none); }\r\n.leading-tight { line-height: var(--line-height-tight); }\r\n.leading-snug { line-height: var(--line-height-snug); }\r\n.leading-normal { line-height: var(--line-height-normal); }\r\n.leading-relaxed { line-height: var(--line-height-relaxed); }\r\n.leading-loose { line-height: var(--line-height-loose); }\r\n\r\n/* Letter Spacing */\r\n.tracking-tighter { letter-spacing: var(--letter-spacing-tighter); }\r\n.tracking-tight { letter-spacing: var(--letter-spacing-tight); }\r\n.tracking-normal { letter-spacing: var(--letter-spacing-normal); }\r\n.tracking-wide { letter-spacing: var(--letter-spacing-wide); }\r\n.tracking-wider { letter-spacing: var(--letter-spacing-wider); }\r\n.tracking-widest { letter-spacing: var(--letter-spacing-widest); }\r\n\r\n/* Text Colors (Extended) */\r\n.text-success { color: var(--color-success); }\r\n.text-warning { color: var(--color-warning); }\r\n.text-error { color: var(--color-error); }\r\n.text-info { color: var(--color-info); }\r\n.text-white { color: white; }\r\n.text-black { color: black; }\r\n\r\n/* Text Utilities */\r\n.text-uppercase { text-transform: uppercase; }\r\n.text-lowercase { text-transform: lowercase; }\r\n.text-capitalize { text-transform: capitalize; }\r\n.text-truncate {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.text-ellipsis {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.text-clip {\r\n  text-overflow: clip;\r\n}\r\n\r\n/* ==========================================================================\r\n   Spacing Utilities (Extended)\r\n   ========================================================================== */\r\n\r\n/* Margin Utilities */\r\n.m-1 { margin: var(--spacing-1); }\r\n.m-2 { margin: var(--spacing-2); }\r\n.m-3 { margin: var(--spacing-3); }\r\n.m-4 { margin: var(--spacing-4); }\r\n.m-5 { margin: var(--spacing-5); }\r\n.m-6 { margin: var(--spacing-6); }\r\n.m-8 { margin: var(--spacing-8); }\r\n.m-10 { margin: var(--spacing-10); }\r\n.m-12 { margin: var(--spacing-12); }\r\n.m-16 { margin: var(--spacing-16); }\r\n.m-20 { margin: var(--spacing-20); }\r\n.m-24 { margin: var(--spacing-24); }\r\n.m-32 { margin: var(--spacing-32); }\r\n\r\n/* Margin X-axis */\r\n.mx-1 { margin-left: var(--spacing-1); margin-right: var(--spacing-1); }\r\n.mx-2 { margin-left: var(--spacing-2); margin-right: var(--spacing-2); }\r\n.mx-3 { margin-left: var(--spacing-3); margin-right: var(--spacing-3); }\r\n.mx-4 { margin-left: var(--spacing-4); margin-right: var(--spacing-4); }\r\n.mx-6 { margin-left: var(--spacing-6); margin-right: var(--spacing-6); }\r\n.mx-8 { margin-left: var(--spacing-8); margin-right: var(--spacing-8); }\r\n\r\n/* Margin Y-axis */\r\n.my-1 { margin-top: var(--spacing-1); margin-bottom: var(--spacing-1); }\r\n.my-2 { margin-top: var(--spacing-2); margin-bottom: var(--spacing-2); }\r\n.my-3 { margin-top: var(--spacing-3); margin-bottom: var(--spacing-3); }\r\n.my-4 { margin-top: var(--spacing-4); margin-bottom: var(--spacing-4); }\r\n.my-6 { margin-top: var(--spacing-6); margin-bottom: var(--spacing-6); }\r\n.my-8 { margin-top: var(--spacing-8); margin-bottom: var(--spacing-8); }\r\n.my-12 { margin-top: var(--spacing-12); margin-bottom: var(--spacing-12); }\r\n.my-16 { margin-top: var(--spacing-16); margin-bottom: var(--spacing-16); }\r\n.my-20 { margin-top: var(--spacing-20); margin-bottom: var(--spacing-20); }\r\n\r\n/* Margin Top */\r\n.mt-1 { margin-top: var(--spacing-1); }\r\n.mt-2 { margin-top: var(--spacing-2); }\r\n.mt-3 { margin-top: var(--spacing-3); }\r\n.mt-4 { margin-top: var(--spacing-4); }\r\n.mt-6 { margin-top: var(--spacing-6); }\r\n.mt-8 { margin-top: var(--spacing-8); }\r\n.mt-12 { margin-top: var(--spacing-12); }\r\n.mt-16 { margin-top: var(--spacing-16); }\r\n.mt-20 { margin-top: var(--spacing-20); }\r\n\r\n/* Margin Bottom */\r\n.mb-1 { margin-bottom: var(--spacing-1); }\r\n.mb-2 { margin-bottom: var(--spacing-2); }\r\n.mb-3 { margin-bottom: var(--spacing-3); }\r\n.mb-4 { margin-bottom: var(--spacing-4); }\r\n.mb-6 { margin-bottom: var(--spacing-6); }\r\n.mb-8 { margin-bottom: var(--spacing-8); }\r\n.mb-12 { margin-bottom: var(--spacing-12); }\r\n.mb-16 { margin-bottom: var(--spacing-16); }\r\n.mb-20 { margin-bottom: var(--spacing-20); }\r\n\r\n/* Padding Utilities (Extended) */\r\n.p-1 { padding: var(--spacing-1); }\r\n.p-2 { padding: var(--spacing-2); }\r\n.p-3 { padding: var(--spacing-3); }\r\n.p-5 { padding: var(--spacing-5); }\r\n.p-10 { padding: var(--spacing-10); }\r\n.p-12 { padding: var(--spacing-12); }\r\n.p-16 { padding: var(--spacing-16); }\r\n.p-20 { padding: var(--spacing-20); }\r\n.p-24 { padding: var(--spacing-24); }\r\n\r\n/* Padding X-axis */\r\n.px-1 { padding-left: var(--spacing-1); padding-right: var(--spacing-1); }\r\n.px-2 { padding-left: var(--spacing-2); padding-right: var(--spacing-2); }\r\n.px-3 { padding-left: var(--spacing-3); padding-right: var(--spacing-3); }\r\n.px-5 { padding-left: var(--spacing-5); padding-right: var(--spacing-5); }\r\n.px-6 { padding-left: var(--spacing-6); padding-right: var(--spacing-6); }\r\n.px-8 { padding-left: var(--spacing-8); padding-right: var(--spacing-8); }\r\n.px-12 { padding-left: var(--spacing-12); padding-right: var(--spacing-12); }\r\n\r\n/* Padding Y-axis */\r\n.py-1 { padding-top: var(--spacing-1); padding-bottom: var(--spacing-1); }\r\n.py-2 { padding-top: var(--spacing-2); padding-bottom: var(--spacing-2); }\r\n.py-3 { padding-top: var(--spacing-3); padding-bottom: var(--spacing-3); }\r\n.py-5 { padding-top: var(--spacing-5); padding-bottom: var(--spacing-5); }\r\n.py-6 { padding-top: var(--spacing-6); padding-bottom: var(--spacing-6); }\r\n.py-8 { padding-top: var(--spacing-8); padding-bottom: var(--spacing-8); }\r\n.py-12 { padding-top: var(--spacing-12); padding-bottom: var(--spacing-12); }\r\n.py-16 { padding-top: var(--spacing-16); padding-bottom: var(--spacing-16); }\r\n.py-20 { padding-top: var(--spacing-20); padding-bottom: var(--spacing-20); }\r\n\r\n/* ==========================================================================\r\n   Background and Border Utilities\r\n   ========================================================================== */\r\n\r\n/* Background Colors */\r\n.bg-primary { background-color: var(--color-primary); }\r\n.bg-secondary { background-color: var(--color-secondary); }\r\n.bg-success { background-color: var(--color-success); }\r\n.bg-warning { background-color: var(--color-warning); }\r\n.bg-error { background-color: var(--color-error); }\r\n.bg-info { background-color: var(--color-info); }\r\n.bg-surface { background-color: var(--color-surface); }\r\n.bg-surface-elevated { background-color: var(--color-surface-elevated); }\r\n.bg-white { background-color: white; }\r\n.bg-black { background-color: black; }\r\n.bg-transparent { background-color: transparent; }\r\n\r\n/* Background Gradients */\r\n.bg-gradient-primary {\r\n  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-light) 100%);\r\n}\r\n\r\n.bg-gradient-secondary {\r\n  background: linear-gradient(135deg, var(--color-secondary) 0%, var(--color-secondary-light) 100%);\r\n}\r\n\r\n.bg-gradient-to-r {\r\n  background: linear-gradient(to right, var(--color-primary), var(--color-secondary));\r\n}\r\n\r\n.bg-gradient-to-b {\r\n  background: linear-gradient(to bottom, var(--color-primary), var(--color-primary-dark));\r\n}\r\n\r\n/* Border Utilities */\r\n.border { border: var(--border-width-1) solid var(--color-border); }\r\n.border-2 { border: var(--border-width-2) solid var(--color-border); }\r\n.border-4 { border: var(--border-width-4) solid var(--color-border); }\r\n.border-0 { border: 0; }\r\n\r\n.border-t { border-top: var(--border-width-1) solid var(--color-border); }\r\n.border-r { border-right: var(--border-width-1) solid var(--color-border); }\r\n.border-b { border-bottom: var(--border-width-1) solid var(--color-border); }\r\n.border-l { border-left: var(--border-width-1) solid var(--color-border); }\r\n\r\n/* Border Colors */\r\n.border-primary { border-color: var(--color-primary); }\r\n.border-secondary { border-color: var(--color-secondary); }\r\n.border-success { border-color: var(--color-success); }\r\n.border-warning { border-color: var(--color-warning); }\r\n.border-error { border-color: var(--color-error); }\r\n.border-transparent { border-color: transparent; }\r\n\r\n/* Border Radius (Extended) */\r\n.rounded-none { border-radius: var(--radius-none); }\r\n.rounded-sm { border-radius: var(--radius-sm); }\r\n.rounded-2xl { border-radius: var(--radius-2xl); }\r\n.rounded-3xl { border-radius: var(--radius-3xl); }\r\n\r\n.rounded-t { border-top-left-radius: var(--radius-base); border-top-right-radius: var(--radius-base); }\r\n.rounded-r { border-top-right-radius: var(--radius-base); border-bottom-right-radius: var(--radius-base); }\r\n.rounded-b { border-bottom-left-radius: var(--radius-base); border-bottom-right-radius: var(--radius-base); }\r\n.rounded-l { border-top-left-radius: var(--radius-base); border-bottom-left-radius: var(--radius-base); }\r\n\r\n/* ==========================================================================\r\n   Flexbox and Grid Utilities (Extended)\r\n   ========================================================================== */\r\n\r\n/* Flex Grow/Shrink */\r\n.flex-grow { flex-grow: 1; }\r\n.flex-grow-0 { flex-grow: 0; }\r\n.flex-shrink { flex-shrink: 1; }\r\n.flex-shrink-0 { flex-shrink: 0; }\r\n\r\n/* Align Self */\r\n.self-auto { align-self: auto; }\r\n.self-start { align-self: flex-start; }\r\n.self-center { align-self: center; }\r\n.self-end { align-self: flex-end; }\r\n.self-stretch { align-self: stretch; }\r\n\r\n/* Order */\r\n.order-1 { order: 1; }\r\n.order-2 { order: 2; }\r\n.order-3 { order: 3; }\r\n.order-first { order: -9999; }\r\n.order-last { order: 9999; }\r\n.order-none { order: 0; }\r\n\r\n/* Grid Utilities (Extended) */\r\n.grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }\r\n.grid-cols-7 { grid-template-columns: repeat(7, minmax(0, 1fr)); }\r\n.grid-cols-8 { grid-template-columns: repeat(8, minmax(0, 1fr)); }\r\n.grid-cols-9 { grid-template-columns: repeat(9, minmax(0, 1fr)); }\r\n.grid-cols-10 { grid-template-columns: repeat(10, minmax(0, 1fr)); }\r\n.grid-cols-11 { grid-template-columns: repeat(11, minmax(0, 1fr)); }\r\n\r\n/* Grid Column Span */\r\n.col-span-1 { grid-column: span 1 / span 1; }\r\n.col-span-2 { grid-column: span 2 / span 2; }\r\n.col-span-3 { grid-column: span 3 / span 3; }\r\n.col-span-4 { grid-column: span 4 / span 4; }\r\n.col-span-5 { grid-column: span 5 / span 5; }\r\n.col-span-6 { grid-column: span 6 / span 6; }\r\n.col-span-full { grid-column: 1 / -1; }\r\n\r\n/* Grid Row Span */\r\n.row-span-1 { grid-row: span 1 / span 1; }\r\n.row-span-2 { grid-row: span 2 / span 2; }\r\n.row-span-3 { grid-row: span 3 / span 3; }\r\n.row-span-4 { grid-row: span 4 / span 4; }\r\n.row-span-full { grid-row: 1 / -1; }\r\n\r\n/* Gap Utilities (Extended) */\r\n.gap-0 { gap: 0; }\r\n.gap-0-5 { gap: var(--spacing-0-5); }\r\n.gap-1-5 { gap: var(--spacing-1-5); }\r\n.gap-5 { gap: var(--spacing-5); }\r\n.gap-10 { gap: var(--spacing-10); }\r\n.gap-12 { gap: var(--spacing-12); }\r\n.gap-16 { gap: var(--spacing-16); }\r\n.gap-20 { gap: var(--spacing-20); }\r\n\r\n.gap-x-1 { column-gap: var(--spacing-1); }\r\n.gap-x-2 { column-gap: var(--spacing-2); }\r\n.gap-x-4 { column-gap: var(--spacing-4); }\r\n.gap-x-6 { column-gap: var(--spacing-6); }\r\n.gap-x-8 { column-gap: var(--spacing-8); }\r\n\r\n.gap-y-1 { row-gap: var(--spacing-1); }\r\n.gap-y-2 { row-gap: var(--spacing-2); }\r\n.gap-y-4 { row-gap: var(--spacing-4); }\r\n.gap-y-6 { row-gap: var(--spacing-6); }\r\n.gap-y-8 { row-gap: var(--spacing-8); }\r\n\r\n/* ==========================================================================\r\n   Width and Height Utilities\r\n   ========================================================================== */\r\n\r\n/* Width */\r\n.w-auto { width: auto; }\r\n.w-full { width: 100%; }\r\n.w-screen { width: 100vw; }\r\n.w-min { width: min-content; }\r\n.w-max { width: max-content; }\r\n.w-fit { width: fit-content; }\r\n\r\n.w-1\\/2 { width: 50%; }\r\n.w-1\\/3 { width: 33.333333%; }\r\n.w-2\\/3 { width: 66.666667%; }\r\n.w-1\\/4 { width: 25%; }\r\n.w-3\\/4 { width: 75%; }\r\n.w-1\\/5 { width: 20%; }\r\n.w-2\\/5 { width: 40%; }\r\n.w-3\\/5 { width: 60%; }\r\n.w-4\\/5 { width: 80%; }\r\n\r\n/* Height */\r\n.h-auto { height: auto; }\r\n.h-full { height: 100%; }\r\n.h-screen { height: 100vh; }\r\n.h-min { height: min-content; }\r\n.h-max { height: max-content; }\r\n.h-fit { height: fit-content; }\r\n\r\n.h-1\\/2 { height: 50%; }\r\n.h-1\\/3 { height: 33.333333%; }\r\n.h-2\\/3 { height: 66.666667%; }\r\n.h-1\\/4 { height: 25%; }\r\n.h-3\\/4 { height: 75%; }\r\n\r\n/* Min/Max Width */\r\n.min-w-0 { min-width: 0px; }\r\n.min-w-full { min-width: 100%; }\r\n.min-w-min { min-width: min-content; }\r\n.min-w-max { min-width: max-content; }\r\n\r\n.max-w-none { max-width: none; }\r\n.max-w-xs { max-width: 20rem; }\r\n.max-w-sm { max-width: 24rem; }\r\n.max-w-md { max-width: 28rem; }\r\n.max-w-lg { max-width: 32rem; }\r\n.max-w-xl { max-width: 36rem; }\r\n.max-w-2xl { max-width: 42rem; }\r\n.max-w-3xl { max-width: 48rem; }\r\n.max-w-4xl { max-width: 56rem; }\r\n.max-w-5xl { max-width: 64rem; }\r\n.max-w-6xl { max-width: 72rem; }\r\n.max-w-7xl { max-width: 80rem; }\r\n.max-w-full { max-width: 100%; }\r\n.max-w-screen-sm { max-width: var(--breakpoint-sm); }\r\n.max-w-screen-md { max-width: var(--breakpoint-md); }\r\n.max-w-screen-lg { max-width: var(--breakpoint-lg); }\r\n.max-w-screen-xl { max-width: var(--breakpoint-xl); }\r\n\r\n/* Min/Max Height */\r\n.min-h-0 { min-height: 0px; }\r\n.min-h-full { min-height: 100%; }\r\n.min-h-screen { min-height: 100vh; }\r\n\r\n.max-h-full { max-height: 100%; }\r\n.max-h-screen { max-height: 100vh; }\r\n\r\n/* ==========================================================================\r\n   Animation and Transform Utilities\r\n   ========================================================================== */\r\n\r\n/* Transform */\r\n.transform { transform: translateX(var(--tw-translate-x, 0)) translateY(var(--tw-translate-y, 0)) rotate(var(--tw-rotate, 0)) skewX(var(--tw-skew-x, 0)) skewY(var(--tw-skew-y, 0)) scaleX(var(--tw-scale-x, 1)) scaleY(var(--tw-scale-y, 1)); }\r\n.transform-none { transform: none; }\r\n\r\n/* Scale */\r\n.scale-0 { transform: scale(0); }\r\n.scale-50 { transform: scale(0.5); }\r\n.scale-75 { transform: scale(0.75); }\r\n.scale-90 { transform: scale(0.9); }\r\n.scale-95 { transform: scale(0.95); }\r\n.scale-100 { transform: scale(1); }\r\n.scale-105 { transform: scale(1.05); }\r\n.scale-110 { transform: scale(1.1); }\r\n.scale-125 { transform: scale(1.25); }\r\n.scale-150 { transform: scale(1.5); }\r\n\r\n/* Rotate */\r\n.rotate-0 { transform: rotate(0deg); }\r\n.rotate-1 { transform: rotate(1deg); }\r\n.rotate-2 { transform: rotate(2deg); }\r\n.rotate-3 { transform: rotate(3deg); }\r\n.rotate-6 { transform: rotate(6deg); }\r\n.rotate-12 { transform: rotate(12deg); }\r\n.rotate-45 { transform: rotate(45deg); }\r\n.rotate-90 { transform: rotate(90deg); }\r\n.rotate-180 { transform: rotate(180deg); }\r\n\r\n/* Translate */\r\n.translate-x-0 { transform: translateX(0px); }\r\n.translate-x-1 { transform: translateX(var(--spacing-1)); }\r\n.translate-x-2 { transform: translateX(var(--spacing-2)); }\r\n.translate-x-4 { transform: translateX(var(--spacing-4)); }\r\n.translate-x-8 { transform: translateX(var(--spacing-8)); }\r\n\r\n.translate-y-0 { transform: translateY(0px); }\r\n.translate-y-1 { transform: translateY(var(--spacing-1)); }\r\n.translate-y-2 { transform: translateY(var(--spacing-2)); }\r\n.translate-y-4 { transform: translateY(var(--spacing-4)); }\r\n.translate-y-8 { transform: translateY(var(--spacing-8)); }\r\n\r\n/* Animation Classes */\r\n.animate-spin {\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n.animate-ping {\r\n  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\r\n}\r\n\r\n.animate-pulse {\r\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\r\n}\r\n\r\n.animate-bounce {\r\n  animation: bounce 1s infinite;\r\n}\r\n\r\n.animate-fade-in {\r\n  animation: fadeIn 0.5s ease-in-out;\r\n}\r\n\r\n.animate-slide-in-up {\r\n  animation: slideInUp 0.5s ease-out;\r\n}\r\n\r\n.animate-slide-in-down {\r\n  animation: slideInDown 0.5s ease-out;\r\n}\r\n\r\n.animate-slide-in-left {\r\n  animation: slideInLeft 0.5s ease-out;\r\n}\r\n\r\n.animate-slide-in-right {\r\n  animation: slideInRight 0.5s ease-out;\r\n}\r\n\r\n@keyframes ping {\r\n  75%, 100% {\r\n    transform: scale(2);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% {\r\n    opacity: 1;\r\n  }\r\n  50% {\r\n    opacity: .5;\r\n  }\r\n}\r\n\r\n@keyframes bounce {\r\n  0%, 100% {\r\n    transform: translateY(-25%);\r\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\r\n  }\r\n  50% {\r\n    transform: translateY(0);\r\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\r\n  }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes slideInUp {\r\n  from {\r\n    transform: translateY(100%);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes slideInDown {\r\n  from {\r\n    transform: translateY(-100%);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes slideInLeft {\r\n  from {\r\n    transform: translateX(-100%);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateX(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes slideInRight {\r\n  from {\r\n    transform: translateX(100%);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateX(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* ==========================================================================\r\n   Component-Specific Styles\r\n   ========================================================================== */\r\n\r\n/* Hero Section */\r\n.hero {\r\n  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-light) 100%);\r\n  color: white;\r\n  padding: var(--spacing-32) 0 var(--spacing-20);\r\n  margin-top: 70px; /* Account for fixed navigation */\r\n  text-align: center;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.hero::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.1);\r\n  z-index: 1;\r\n}\r\n\r\n.hero-actions {\r\n  display: flex;\r\n  gap: var(--spacing-4);\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* Stats Section */\r\n.stats-section {\r\n  padding: var(--spacing-20) 0;\r\n  background-color: var(--color-surface);\r\n}\r\n\r\n.stats-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: var(--spacing-8);\r\n  text-align: center;\r\n}\r\n\r\n.stat-item {\r\n  padding: var(--spacing-6);\r\n  background: var(--color-surface-elevated);\r\n  border-radius: var(--radius-xl);\r\n  box-shadow: var(--shadow-sm);\r\n  transition: all var(--transition-base);\r\n}\r\n\r\n.stat-item:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.stat-value {\r\n  font-size: var(--font-size-4xl);\r\n  font-weight: var(--font-weight-extrabold);\r\n  color: var(--color-primary);\r\n  margin-bottom: var(--spacing-2);\r\n  line-height: var(--line-height-none);\r\n}\r\n\r\n.stat-label {\r\n  font-size: var(--font-size-lg);\r\n  color: var(--color-text-secondary);\r\n  font-weight: var(--font-weight-medium);\r\n  text-transform: uppercase;\r\n  letter-spacing: var(--letter-spacing-wide);\r\n}\r\n\r\n/* Courses Overview */\r\n.courses-overview {\r\n  padding: var(--spacing-20) 0;\r\n}\r\n\r\n.section-title {\r\n  text-align: center;\r\n  font-size: var(--font-size-4xl);\r\n  margin-bottom: var(--spacing-12);\r\n  color: var(--color-text);\r\n  font-weight: var(--font-weight-extrabold);\r\n}\r\n\r\n.courses-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: var(--spacing-8);\r\n}\r\n\r\n/* Footer */\r\n.footer {\r\n  background-color: var(--color-primary);\r\n  color: white;\r\n  padding: var(--spacing-16) 0 var(--spacing-8);\r\n}\r\n\r\n.footer-content {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n  gap: var(--spacing-8);\r\n  margin-bottom: var(--spacing-8);\r\n}\r\n\r\n.footer-section h3,\r\n.footer-section h4 {\r\n  margin-bottom: var(--spacing-4);\r\n  color: white;\r\n  font-weight: var(--font-weight-bold);\r\n}\r\n\r\n.footer-section ul {\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n\r\n.footer-section ul li {\r\n  margin-bottom: var(--spacing-2);\r\n}\r\n\r\n.footer-section ul li a {\r\n  color: rgba(255, 255, 255, 0.8);\r\n  text-decoration: none;\r\n  transition: color var(--transition-fast);\r\n}\r\n\r\n.footer-section ul li a:hover {\r\n  color: white;\r\n  text-decoration: underline;\r\n}\r\n\r\n.footer-bottom {\r\n  text-align: center;\r\n  padding-top: var(--spacing-8);\r\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\r\n  color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n/* Loading Overlay */\r\n.loading-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  backdrop-filter: blur(4px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: var(--z-modal);\r\n}\r\n\r\n.loading-spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid var(--color-border);\r\n  border-top: 4px solid var(--color-primary);\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n/* Toast Notifications */\r\n.toast {\r\n  position: fixed;\r\n  top: var(--spacing-4);\r\n  right: var(--spacing-4);\r\n  background-color: var(--color-surface-elevated);\r\n  color: var(--color-text);\r\n  padding: var(--spacing-4) var(--spacing-6);\r\n  border-radius: var(--radius-lg);\r\n  box-shadow: var(--shadow-lg);\r\n  border: 1px solid var(--color-border);\r\n  z-index: var(--z-toast);\r\n  animation: slideInRight 0.3s ease-out;\r\n  max-width: 400px;\r\n  min-width: 300px;\r\n}\r\n\r\n.toast.success {\r\n  border-left: 4px solid var(--color-success);\r\n}\r\n\r\n.toast.error {\r\n  border-left: 4px solid var(--color-error);\r\n}\r\n\r\n.toast.warning {\r\n  border-left: 4px solid var(--color-warning);\r\n}\r\n\r\n.toast.info {\r\n  border-left: 4px solid var(--color-info);\r\n}\r\n\r\n/* Form Styles */\r\n.form-group {\r\n  margin-bottom: var(--spacing-4);\r\n}\r\n\r\n.form-label {\r\n  display: block;\r\n  margin-bottom: var(--spacing-2);\r\n  font-weight: var(--font-weight-medium);\r\n  color: var(--color-text);\r\n}\r\n\r\n.form-input {\r\n  width: 100%;\r\n  padding: var(--spacing-3) var(--spacing-4);\r\n  border: 1px solid var(--color-border);\r\n  border-radius: var(--radius-md);\r\n  background-color: var(--color-surface);\r\n  color: var(--color-text);\r\n  font-size: var(--font-size-base);\r\n  transition: all var(--transition-fast);\r\n}\r\n\r\n.form-input:focus {\r\n  outline: none;\r\n  border-color: var(--color-primary);\r\n  box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb), 0.1);\r\n}\r\n\r\n.form-input.error {\r\n  border-color: var(--color-error);\r\n}\r\n\r\n.form-input.success {\r\n  border-color: var(--color-success);\r\n}\r\n\r\n.form-error {\r\n  color: var(--color-error);\r\n  font-size: var(--font-size-sm);\r\n  margin-top: var(--spacing-1);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--spacing-1);\r\n}\r\n\r\n.form-success {\r\n  color: var(--color-success);\r\n  font-size: var(--font-size-sm);\r\n  margin-top: var(--spacing-1);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--spacing-1);\r\n}\r\n\r\n/* Button Sizes */\r\n.btn-xs {\r\n  padding: var(--spacing-1) var(--spacing-2);\r\n  font-size: var(--font-size-xs);\r\n}\r\n\r\n.btn-sm {\r\n  padding: var(--spacing-2) var(--spacing-4);\r\n  font-size: var(--font-size-sm);\r\n}\r\n\r\n.btn-lg {\r\n  padding: var(--spacing-4) var(--spacing-8);\r\n  font-size: var(--font-size-lg);\r\n}\r\n\r\n.btn-xl {\r\n  padding: var(--spacing-5) var(--spacing-10);\r\n  font-size: var(--font-size-xl);\r\n}\r\n\r\n/* Card Component */\r\n.card {\r\n  background-color: var(--color-surface);\r\n  border: 1px solid var(--color-border);\r\n  border-radius: var(--radius-lg);\r\n  box-shadow: var(--shadow-sm);\r\n  overflow: hidden;\r\n  transition: all var(--transition-base);\r\n}\r\n\r\n.card:hover {\r\n  box-shadow: var(--shadow-md);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.card-header {\r\n  padding: var(--spacing-6);\r\n  border-bottom: 1px solid var(--color-border);\r\n  background-color: var(--color-surface-elevated);\r\n}\r\n\r\n.card-body {\r\n  padding: var(--spacing-6);\r\n}\r\n\r\n.card-footer {\r\n  padding: var(--spacing-6);\r\n  border-top: 1px solid var(--color-border);\r\n  background-color: var(--color-surface-elevated);\r\n}\r\n\r\n/* Badge Component */\r\n.badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: var(--spacing-1) var(--spacing-2);\r\n  font-size: var(--font-size-xs);\r\n  font-weight: var(--font-weight-medium);\r\n  border-radius: var(--radius-full);\r\n  text-transform: uppercase;\r\n  letter-spacing: var(--letter-spacing-wide);\r\n}\r\n\r\n.badge-primary {\r\n  background-color: var(--color-primary);\r\n  color: white;\r\n}\r\n\r\n.badge-secondary {\r\n  background-color: var(--color-secondary);\r\n  color: white;\r\n}\r\n\r\n.badge-success {\r\n  background-color: var(--color-success);\r\n  color: white;\r\n}\r\n\r\n.badge-warning {\r\n  background-color: var(--color-warning);\r\n  color: white;\r\n}\r\n\r\n.badge-error {\r\n  background-color: var(--color-error);\r\n  color: white;\r\n}\r\n\r\n.badge-outline {\r\n  background-color: transparent;\r\n  border: 1px solid var(--color-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n/* ==========================================================================\r\n   Responsive Design Utilities\r\n   ========================================================================== */\r\n\r\n/* Mobile First Responsive Utilities */\r\n@media (min-width: 475px) {\r\n  .xs\\:block { display: block; }\r\n  .xs\\:hidden { display: none; }\r\n  .xs\\:flex { display: flex; }\r\n  .xs\\:grid { display: grid; }\r\n  .xs\\:text-center { text-align: center; }\r\n  .xs\\:text-left { text-align: left; }\r\n}\r\n\r\n@media (min-width: 640px) {\r\n  .sm\\:block { display: block; }\r\n  .sm\\:hidden { display: none; }\r\n  .sm\\:flex { display: flex; }\r\n  .sm\\:grid { display: grid; }\r\n  .sm\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\r\n  .sm\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\r\n  .sm\\:flex-row { flex-direction: row; }\r\n  .sm\\:flex-col { flex-direction: column; }\r\n  .sm\\:text-left { text-align: left; }\r\n  .sm\\:text-center { text-align: center; }\r\n  .sm\\:text-right { text-align: right; }\r\n  .sm\\:p-6 { padding: var(--spacing-6); }\r\n  .sm\\:px-6 { padding-left: var(--spacing-6); padding-right: var(--spacing-6); }\r\n  .sm\\:py-8 { padding-top: var(--spacing-8); padding-bottom: var(--spacing-8); }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .md\\:block { display: block; }\r\n  .md\\:hidden { display: none; }\r\n  .md\\:flex { display: flex; }\r\n  .md\\:grid { display: grid; }\r\n  .md\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\r\n  .md\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\r\n  .md\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\r\n  .md\\:flex-row { flex-direction: row; }\r\n  .md\\:flex-col { flex-direction: column; }\r\n  .md\\:text-left { text-align: left; }\r\n  .md\\:text-center { text-align: center; }\r\n  .md\\:text-right { text-align: right; }\r\n  .md\\:text-lg { font-size: var(--font-size-lg); }\r\n  .md\\:text-xl { font-size: var(--font-size-xl); }\r\n  .md\\:text-2xl { font-size: var(--font-size-2xl); }\r\n  .md\\:text-3xl { font-size: var(--font-size-3xl); }\r\n  .md\\:p-8 { padding: var(--spacing-8); }\r\n  .md\\:px-8 { padding-left: var(--spacing-8); padding-right: var(--spacing-8); }\r\n  .md\\:py-12 { padding-top: var(--spacing-12); padding-bottom: var(--spacing-12); }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n  .lg\\:block { display: block; }\r\n  .lg\\:hidden { display: none; }\r\n  .lg\\:flex { display: flex; }\r\n  .lg\\:grid { display: grid; }\r\n  .lg\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\r\n  .lg\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\r\n  .lg\\:grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }\r\n  .lg\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }\r\n  .lg\\:flex-row { flex-direction: row; }\r\n  .lg\\:flex-col { flex-direction: column; }\r\n  .lg\\:text-left { text-align: left; }\r\n  .lg\\:text-center { text-align: center; }\r\n  .lg\\:text-right { text-align: right; }\r\n  .lg\\:text-xl { font-size: var(--font-size-xl); }\r\n  .lg\\:text-2xl { font-size: var(--font-size-2xl); }\r\n  .lg\\:text-3xl { font-size: var(--font-size-3xl); }\r\n  .lg\\:text-4xl { font-size: var(--font-size-4xl); }\r\n  .lg\\:p-12 { padding: var(--spacing-12); }\r\n  .lg\\:px-12 { padding-left: var(--spacing-12); padding-right: var(--spacing-12); }\r\n  .lg\\:py-16 { padding-top: var(--spacing-16); padding-bottom: var(--spacing-16); }\r\n}\r\n\r\n@media (min-width: 1280px) {\r\n  .xl\\:block { display: block; }\r\n  .xl\\:hidden { display: none; }\r\n  .xl\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\r\n  .xl\\:grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }\r\n  .xl\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }\r\n  .xl\\:text-2xl { font-size: var(--font-size-2xl); }\r\n  .xl\\:text-3xl { font-size: var(--font-size-3xl); }\r\n  .xl\\:text-4xl { font-size: var(--font-size-4xl); }\r\n  .xl\\:text-5xl { font-size: var(--font-size-5xl); }\r\n}\r\n\r\n@media (min-width: 1536px) {\r\n  .2xl\\:block { display: block; }\r\n  .2xl\\:hidden { display: none; }\r\n  .2xl\\:grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }\r\n  .2xl\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }\r\n  .2xl\\:text-3xl { font-size: var(--font-size-3xl); }\r\n  .2xl\\:text-4xl { font-size: var(--font-size-4xl); }\r\n  .2xl\\:text-5xl { font-size: var(--font-size-5xl); }\r\n  .2xl\\:text-6xl { font-size: var(--font-size-6xl); }\r\n}\r\n\r\n/* ==========================================================================\r\n   Mobile Responsive Adjustments\r\n   ========================================================================== */\r\n\r\n@media (max-width: 768px) {\r\n  .hero {\r\n    padding: var(--spacing-20) 0 var(--spacing-16);\r\n  }\r\n  \r\n  .hero-title {\r\n    font-size: var(--font-size-3xl);\r\n  }\r\n  \r\n  .hero-subtitle {\r\n    font-size: var(--font-size-lg);\r\n  }\r\n  \r\n  .hero-actions {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n  \r\n  .stats-grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: var(--spacing-4);\r\n  }\r\n  \r\n  .courses-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .section-title {\r\n    font-size: var(--font-size-3xl);\r\n  }\r\n  \r\n  .toast {\r\n    left: var(--spacing-4);\r\n    right: var(--spacing-4);\r\n    max-width: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .stats-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .stat-value {\r\n    font-size: var(--font-size-3xl);\r\n  }\r\n  \r\n  .hero-title {\r\n    font-size: var(--font-size-2xl);\r\n  }\r\n  \r\n  .section-title {\r\n    font-size: var(--font-size-2xl);\r\n  }\r\n  \r\n\r\n}\r\n\r\n/* ==========================================================================\r\n   Print Styles\r\n   ========================================================================== */\r\n\r\n@media print {\r\n  .no-print {\r\n    display: none !important;\r\n  }\r\n  \r\n  .hero,\r\n  .navigation,\r\n  .footer,\r\n  .toast,\r\n  .loading-overlay {\r\n    display: none !important;\r\n  }\r\n  \r\n  * {\r\n    background: white !important;\r\n    color: black !important;\r\n    box-shadow: none !important;\r\n  }\r\n  \r\n  a {\r\n    text-decoration: underline !important;\r\n  }\r\n  \r\n  .container {\r\n    max-width: none !important;\r\n    padding: 0 !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
